module.exports = __webpack_public_path__ + "img/节点@2x.87830c01.png";